import type { AiAppCenterModule } from '../types'

/**
 * 汽车会员营销
 * 后端 system_module.name=car；独立窗 app=car，路径 /car
 */
export const carModule: AiAppCenterModule = {
  key: 'car',
  label: '汽车会员营销',
  desc: '车辆 / 服务单 / 次卡储值券 / 门店预约分佣',
  path: '/car',
  homePath: '/car/merchant',
  menuPaths: ['/car'],
  icon: 'ep:van',
  color: '#0ea5e9',
  aliases: ['汽车', '汽车服务', '汽车会员']
}
